// extracted by mini-css-extract-plugin
module.exports = {"container":"_3sGv3","title":"_3QYiG","smallerText":"OjsYl"};